import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ReportsRoutingModule } from './reports-routing.module';
import { SalesComponent } from './sales/sales.component';
import { OrderComponent } from './order/order.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [DashboardComponent, SalesComponent, OrderComponent],
  imports: [CommonModule, ReportsRoutingModule],
})
export class ReportsModule {}
